module.exports = __webpack_public_path__ + "img/Group 28014@2x.8f165859.png";